import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { BackOfficeLoansStore } from '../stores/backOfficeLoansStore';
export const useBackOfficeLoansStore = () =>
  useContext<{
    backOfficeLoansStore: BackOfficeLoansStore;
  }>(StoreContext);
